var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_570_1154",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21C13.1821 21.0015 14.3529 20.7694 15.445 20.317C16.5372 19.8646 17.5291 19.2009 18.3639 18.3639C19.2009 17.5291 19.8646 16.5372 20.317 15.445C20.7694 14.3529 21.0015 13.1821 21 12C21.0015 10.8179 20.7694 9.64712 20.317 8.555C19.8646 7.46287 19.2009 6.4709 18.3639 5.63611C17.5291 4.79912 16.5372 4.13536 15.445 3.68297C14.3529 3.23057 13.1821 2.99848 12 3.00001C10.8179 2.9985 9.64712 3.23061 8.555 3.683C7.46287 4.13539 6.4709 4.79914 5.63611 5.63611C4.79914 6.4709 4.13539 7.46287 3.683 8.555C3.23061 9.64712 2.9985 10.8179 3.00001 12C2.99848 13.1821 3.23057 14.3529 3.68297 15.445C4.13536 16.5372 4.79912 17.5291 5.63611 18.3639C6.4709 19.2009 7.46287 19.8646 8.555 20.317C9.64712 20.7694 10.8179 21.0015 12 21Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39941 11.9998L11.0994 14.6998L16.4994 9.2998",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_570_1154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2002 1.2002H22.8002V22.8002H1.2002V1.2002Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrue);
export default __webpack_public_path__ + "static/media/true.b4ad42976a5fc112b8d8522d528f2f7d.svg";
export { ForwardRef as ReactComponent };